import { useDndContext, useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import DraggableVesselCard from "./DraggableVesselCard";

const { Title } = Typography;

const KanbanColumn = ({ id, title, subtitle, vessels, isHoliday, onVesselClick, }) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { root: null, threshold: 0.75 }
    );
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  }, []);

  const { over } = useDndContext();
  const { setNodeRef } = useDroppable({ id, data: { columnId: id }, disabled: !isVisible });
  const isDroppingOverColumn = over?.id === id || over?.data?.current?.columnId === id;

  return (
    <div
      ref={(el) => {
        containerRef.current = el;
        setNodeRef(el);
      }}
      style={{
        width: 152,
        margin: "0 2px",
        flex: "0 0 auto",
        display: "flex",
        flexDirection: "column",
        height: title === "Emptied" ? "calc(100vh - 80px)" : "calc(100vh - 170px)",
        background: isDroppingOverColumn ? "#E6F7FF" : "#F0F2F5",
        borderRadius: 4,
        overflow: "hidden",
        position: "relative",
        zIndex: isVisible ? 2 : 0,
      }}
      className={title === "Emptied" ? "!rounded-se-3xl" : ""}
    >
      <div
        style={{
          backgroundColor: isDroppingOverColumn ? "#E6F7FF" : (isHoliday ? "#E8EDED" : "#F8F8F8"),
          textAlign: "center",
        }}
      >
        <Title level={5} className={`text-[#1E1E1E] ${title === "Emptied" ? "!font-medium font-inter !text-[26px] text-[#1E1E1E] !mt-[16px] !mb-[8px]" : "!mt-[8px] !mx-0 !mb-0"}`} style={{ fontSize: title === "Emptied" ? 24 : 18 }}>
          {title.toUpperCase()}
        </Title>
        <div className="text-[12px] text-[#777777] font-inter">{subtitle.toUpperCase()}</div>
      </div>
      <div style={{ flex: 1, overflowY: "auto", scrollbarWidth: "none", msOverflowStyle: "none", padding: 4, backgroundColor: isDroppingOverColumn ? "#E6F7FF" : (isHoliday ? "#E8EDED" : "#F8F8F8") }}>
        <SortableContext
          items={vessels.map((v) => v.id.toString())}
          strategy={verticalListSortingStrategy}
        >
          {vessels.map((vessel) => (
            <DraggableVesselCard
              key={vessel.id}
              vessel={vessel}
              columnId={id}
              onVesselClick={onVesselClick}
            />
          ))}
        </SortableContext>
      </div>
    </div>
  );
};

export default KanbanColumn;